export const SESSION_TOKENS = {
  ACCESS: 'accessToken',
  REFRESH: 'refreshToken',
  ID: 'idToken'
}
